var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart-stock-trend',{style:(_vm.chart_style()),attrs:{"options":_vm.line,"autoresize":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }